import type { ConfirmOptions } from "./use-confirm";

type ConfirmFn = (o: ConfirmOptions) => Promise<boolean>;

// Shared "you have unsaved changes — leave anyway?" confirmation, used by
// NavigationGuardProvider for every way out of a dirty document editor so the
// wording and tone stay identical.
export function confirmDiscardNavigation(confirm: ConfirmFn): Promise<boolean> {
  return confirm({
    title: "未保存の変更を破棄して移動しますか？",
    description: "保存していない本文の変更は失われます。",
    confirmLabel: "移動する",
    tone: "danger",
  });
}
